import { Component, OnInit } from '@angular/core';
import { Shop } from '@app/services/shops/shop.model';
import { ShopService } from '@app/services/shops/shop.service';
import { filter } from 'rxjs';

@Component({
  selector: 'settings-page',
  templateUrl: './settings-page.component.html',
  styleUrls: ['./settings-page.component.scss'],
  standalone: false,
})
export class SettingsPageComponent implements OnInit {
  shop: Shop;
  constructor(public shopService: ShopService) {}

  ngOnInit(): void {
    this.shopService.shop$.pipe(filter((shop) => !!shop)).subscribe((shop) => {
      this.shop = shop;
    });
  }
}
